import {CoreSettingsParameters, ISettings, SettingsParametersSchema} from '@gongxigames/framework/core';
import {GameClientWrapperSettingsParameters, SlotSettingsParameters} from '@gongxigames/framework/slot';

export interface RubyPlayGameClientWrapperSettingsParameters {
    key: string;
    playerSession: string;
    operator: string;
    initUrl: string;
    gsUrl: string;
    serverUrl: string;
    subunit: number;
    pingBalanceDelay: number;
    pingBalanceIgnoreCache: boolean;
    stId?: string;
    stName?: string;
}

export const HTTP_CLIENT_WRAPPER_SETTINGS_PARAMETERS_SCHEMA: SettingsParametersSchema<RubyPlayGameClientWrapperSettingsParameters> = {
    serverUrl: {
        readonly: true,
        defaultValue: '',
        urlParser: {
            alias: 'server_url',
            typePropertyInURL: 'string'
        }
    },
    initUrl: {
        readonly: true,
        defaultValue: '',
        urlParser: {
            alias: 'init_url',
            typePropertyInURL: 'string'
        }
    },
    gsUrl: {
        readonly: true,
        defaultValue: '',
        urlParser: {
            alias: 'gs_url',
            typePropertyInURL: 'string'
        }
    },
    key: {
        readonly: true,
        defaultValue: '',
        urlParser: {
            typePropertyInURL: 'string'
        }
    },
    playerSession: {
        readonly: true,
        defaultValue: '',
        urlParser: {
            typePropertyInURL: 'string',
            parseValue: value => {
                return encodeURIComponent(value);
            }
        }
    },
    operator: {
        readonly: true,
        defaultValue: '',
        urlParser: {
            typePropertyInURL: 'string'
        }
    },
    subunit: {
        readonly: true,
        defaultValue: 0
    },
    pingBalanceDelay: {
        readonly: false,
        defaultValue: 60000
    },
    pingBalanceIgnoreCache: {
        readonly: true,
        defaultValue: false
    },
    stId: {
        readonly: true,
        defaultValue: '',
        urlParser: {
            typePropertyInURL: 'string'
        }
    },
    stName: {
        readonly: true,
        defaultValue: '',
        urlParser: {
            typePropertyInURL: 'string'
        }
    }
};

export type RubyPlayGameClientWrapperSettings = ISettings<
    CoreSettingsParameters &
    SlotSettingsParameters &
    GameClientWrapperSettingsParameters &
    RubyPlayGameClientWrapperSettingsParameters
>;
